import {Component, computed, inject, OnInit} from '@angular/core';
import {TaAppStore} from '../../../state/clcta-store';
import {FormsModule} from '@angular/forms';
import {CreateTaStepType, isFlightOnlyTa, toTAStatusText} from '../../../util/app.types';
import {Chip} from 'primeng/chip';
import {ViewTaComponent} from '../../components/view-ta/view-ta.component';
import {TAStatus} from '../../../api';
import {TaCostBubbleComponent} from '../../components/ta-cost-bubble/ta-cost-bubble.component';

@Component({
  selector: 'clc-view-ta-page',
  imports: [
    FormsModule,
    Chip,
    ViewTaComponent,
    TaCostBubbleComponent,
  ],
  templateUrl: './clc-view-ta-page.html',
  styleUrl: './clc-view-ta-page.scss'
})
export class ClcViewTaPage implements OnInit {
  store = inject(TaAppStore);
  status = computed<TAStatus | undefined>(() => this.store.taSubmission()?.status)
  isFlightOnly = computed<boolean>(() => isFlightOnlyTa(this.store.taSubmission()))
  currentTaValue = computed(() => this.store.taSubmission()?.currentValue ?? 0)
  isAcquitted = computed<boolean>(() => ['AcquittalComplete', 'AcquittalApproved', 'Finalised'].includes(this.status() ?? ''))
  // Approved but not yet acquitted; other statuses keep "Total TA Value".
  isApproved = computed<boolean>(() => ['TravelApproved', 'PendingCancelApproval'].includes(this.status() ?? ''))

  ngOnInit() {
    this.store.updateBreadCrumbData({
      title: 'View TA',
      taNumberPrefix: '',
      titleIcon: 'fa-regular fa-location-dot fa-lg'
    });
  }

  protected readonly CreateTaStepType = CreateTaStepType;
  protected readonly toTAStatusText = toTAStatusText;
}

